export default {
    new: 'جديد',
    add: 'إضافة',
    'delete':'حذف',
    'view-invoice': 'عرض الفاتورة',
    'bond-no': 'رقم السند',
    edit: 'تعديل',
    save: 'حفظ',
    bond: 'سند',
    not: 'غير',
    posted: 'مُرحّل',
    'delete-account-entry': 'حذف القيد المُحاسبي',
    'are-you-sure-you-want-to-delete-the-entry': 'هل أنت متأكد من حذف القيد؟',
    'add-bond': 'إضافة سند',
    'bond-date': 'تاريخ سند',
    'create': 'إنشاء',
    'cancel': 'إلغاء',
    'sum': 'المجموع:',
    'difference': 'الفرق:',
    'currency-equivalent': 'الرصيد بعملة مختلفة',
    'select-currency-to-show-the-currency-equivalent': 'اختر العملة لعرض القيمة المُكافئة',

    headers: {
        sequence: 'تسلسل',
        account: 'الحساب',
        debit: 'المدين',
        credit: 'الدائن',
        note: 'البيان',
        currency: 'العملة',
        'currency-debit': 'ع.مدينة',
        'currency-credit': 'ع.دائنة',
        price: 'السعر',
        'paper-document-no': 'م.الورقي',
        'date': 'التاريخ',
    },

    'not-posted-bonds': 'سندات غير مُرحّلة',
    'all-bonds-are-posted': 'جميع السندات مُرحلة',

    'context-menu': {
        'account-statement' : 'كشف حساب',
        'edit' : 'تعديل',
        'delete' : 'حذف'
    },

    'make-sure-the-data-entered-is-correct': 'تأكد من صحة البيانات المدخلة',

    'coming-from': 'قادمة من',
    'journals-by-invoice': 'الفواتير',
    'journals-by-default': 'يدوية',

    footer: {
        'total': 'المجموع',
        'difference': 'الفرق'
    },

    'reverse-divider': 'تبديل القسمة',
    "reverse-currency-price": "تبديل اتجاه حساب سعر العملة",
    "created-from-invoice": "قادمة من فاتورة"
}